/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GlsControllerGetShipmentListByStatus$Params {

/**
 * Filter shipments by status. Leave empty for all shipments.
 */
  status?:  | 0 | 1;
}

export function glsControllerGetShipmentListByStatus(http: HttpClient, rootUrl: string, params?: GlsControllerGetShipmentListByStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<any>>> {
  const rb = new RequestBuilder(rootUrl, glsControllerGetShipmentListByStatus.PATH, 'get');
  if (params) {
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<any>>;
    })
  );
}

glsControllerGetShipmentListByStatus.PATH = '/couriers/gls/list-sped-by-status';
